<template>
  <div class="bienvenida-page"> 

    <!-- 🎥 VIDEO DE FONDO -->
    <video
      class="video-bg"
      autoplay
      muted
      loop
      playsinline
    >
      <source src="@/assets/vv1.mp4" type="video/mp4" />
    </video>

    <div class="overlay"></div>

    <div class="fecha-evento" ref="fechaRef">
      <p class="fecha-gran-dia" ref="granDiaRef">Save the Date</p>
      <p class="fecha-dia-semana" ref="diaSemanaRef">Viernes</p>
      <p class="fecha-dia-numero" ref="numeroRef">22</p>
      <p class="fecha-mes" ref="mesRef">MAYO</p>
      <p class="fecha-anio" ref="anioRef">2026</p>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'BienvenidaPage',
  setup() {
    const fechaRef = ref(null);
    const granDiaRef = ref(null);
    const diaSemanaRef = ref(null);
    const numeroRef = ref(null);
    const mesRef = ref(null);
    const anioRef = ref(null);

    const animateOnScroll = (el, animationFn) => {
      if (!el) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            animationFn();
            observer.unobserve(el);
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(el);
    };

    onMounted(() => {
      animateOnScroll(fechaRef.value, () => {
        const tl = gsap.timeline({ defaults: { ease: 'power2.out' } });

        tl.fromTo(granDiaRef.value, 
          { opacity: 0, y: 30 }, 
          { opacity: 1, y: 0, duration: 0.8 }
        )
        .fromTo(diaSemanaRef.value, 
          { opacity: 0, y: 20 }, 
          { opacity: 1, y: 0, duration: 0.8 }, 
          "-=0.6"
        )
        .fromTo(numeroRef.value, 
          { opacity: 0, y: -80, scale: 0.7 }, 
          { opacity: 1, y: 0, scale: 1, duration: 1.2, ease: 'bounce.out' }, 
          "-=0.4"
        )
        .fromTo(mesRef.value, 
          { opacity: 0, y: 20 }, 
          { opacity: 1, y: 0, duration: 0.8 }, 
          "-=0.8"
        )
        .fromTo(anioRef.value, 
          { opacity: 0, y: 20 }, 
          { opacity: 1, y: 0, duration: 0.8 }, 
          "-=0.6"
        );
      });
    });

    return {
      fechaRef,
      granDiaRef,
      diaSemanaRef,
      numeroRef,
      mesRef,
      anioRef
    };
  }
};
</script>

<style scoped>
.bienvenida-page {
  color: rgb(254, 254, 254);
  min-height: 40vh;
  padding: 0px 20px;
  margin-bottom: 5px;
  z-index: 5;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* 🎥 VIDEO */
.video-bg {
  position: absolute;  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -2;
}

/* 🌫️ Overlay para que se vea el texto */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0); /* ajusta si quieres más oscuro */
  z-index: -1;
}

/* Fecha */
.fecha-evento {
  text-align: center;
  margin: 60px 0 40px;
  color:#fafafa;
}
.fecha-gran-dia {
  font-family: 'british', cursive;
  font-size: 32px;
  margin: 0;
}
.fecha-dia-semana {
  font-family: 'fecha', serif;
  font-size: 29px;
  margin: 10px 0;
}
.fecha-dia-numero {
  font-family: 'fecha', serif;
  font-size: 72px !important;
  font-weight: bold;
  margin: 0;
}
.fecha-mes {
  font-family: 'Playfair Display', serif;
  font-size: 26px;
  font-weight: 600;
  margin-top: 5px;
  letter-spacing: 2px;
}
.fecha-anio {
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-style: italic;
  margin-top: 5px;
}

/* Contenido */
.bienvenida-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mensaje-bienvenida {
  font: 300 19px 'Josefin Sans', sans-serif;
  color: #000;
  white-space: pre-line;
  text-align: center;
  line-height: 2;
  opacity: 0;
}
.versiculo-container {
  margin: 30px 20px 0 20px;
  text-align: center;
  opacity: 0;
}
.versiculo-texto {
  font: 18px 'quote', sans-serif;
  line-height: 1.8;
  color: #333;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.versiculo-referencia-fija {
  font: 24px 'nombre', sans-serif;
  color: #070707;
  margin-top: 40px;
  opacity: 0;
}
.letra-quince {
  font-family: 'british', cursive;
  font-size: 15px;
  color: #000;
  letter-spacing: 1px;
}
.letra-quince1 {
  font-family: 'british', cursive;
  font-size: 19px;
  color: #000;
  letter-spacing: 1px;
}

/* Discos con estrellas */
.disco-group {
  position: absolute;
  opacity: 1;
  pointer-events: none;
  z-index: 2;
  width: 0px !important;
}
.disco {
  width: 100px;
  height: 120px;
}
.estrellas {
  width: 100px;
  position: absolute;
  bottom: -25px;
  left: 0;
  transform: rotate(-10deg);
  opacity: 0;
}

/* Posiciones individuales */
.disco1-group {
  top: -10%;
  right: 0%;
}
.disco2-group {
  top: 30%;
  left: -5%;
  width: 120px;
  height: 140px;
}
.disco3-group {
  bottom: -15%;
  left: -10%;
  z-index:10;
}

.ornamento-medieval{
  width: min(80vw, 500px);
  margin-top: 18px;
  margin-bottom: 18px;
  opacity: 0.95;
  z-index: 3;
  pointer-events: none;
}
</style>